<template>
  <div class="steps">
    <div class="step-item" v-for="(steps, key) in stepList" :key="steps.title" :class="step < (key+1) ? 'wait' : 'finish'">
      <div class="current-step">{{ key + 1 }}</div>
      <div class="current-steptitle">{{ steps.title || key + 1 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 0
    },
    stepList: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<style scoped lang="less">
.steps {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  background-color: #fff;
  transition: all 0.2s;
  &::before {
    content: '';
    width: 100%;
    height: 1px;
    background: #eaecf1;
    position: absolute;
    top: 14px;
  }
  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
    position: relative;
    &:first-child {
      &:before {
        content: '';
        width: calc(50% - 14.5px);
        height: 29px;
        background: #fff;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    &:last-child {
      &:after {
        content: '';
        width: calc(50% - 14.5px);
        height: 29px;
        background: #fff;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .current-step {
      width: 29px;
      height: 29px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-bottom: 11px;
    }
    .current-steptitle {
      font-size: 14px;
    }
    &.finish {
      .current-step {
        background: #4b7dfd;
        color: #fff;
      }
      .current-steptitle {
        color: #4b7dfd;
      }
    }
    &.wait {
      .current-step {
        background: #e1e5e8;
        color: #fff;
      }
      .current-steptitle {
        color: #84878d;
      }
    }
  }
}
</style>
